export const filterObject = (obj: Record<string, any>, keysToExclude: string[]) => {
  return Object.keys(obj)
    .filter((key) => !keysToExclude.includes(key))
    .reduce(
      (acc, key) => {
        acc[key] = obj[key]
        return acc
      },
      {} as Record<string, any>
    )
}
